// src/App.js

import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import components
import NavBar from './components/NavBar';
import Footer from './components/Footer';

// Import pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import VolpeTrackPage from './pages/VolpeTrackPage';
import HoldThenPage from './pages/HoldThenPage';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Sitemap from './pages/Sitemap';
import VolpeTrackPrivacyPolicy from './pages/VolpeTrackPrivacyPolicy';
import VolpeTrackAccountDeletion from './pages/VolpeTrackAccountDeletion';
import VolpeTrackTermsConditions from './pages/VolpeTrackTermsConditions';
import NotFound from './pages/NotFound';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fafafa;
  color: #333;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<Navigate to="/#products" replace />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="/volpetrack" element={<VolpeTrackPage />} />
          <Route path="/holdthen" element={<HoldThenPage />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/volpetrack/privacy" element={<VolpeTrackPrivacyPolicy />} />
          <Route path="/volpetrack/terms" element={<VolpeTrackTermsConditions />} />
          <Route path="/volpetrack/account-deletion" element={<VolpeTrackAccountDeletion />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
